import {Controller} from '@hotwired/stimulus';
import {navigationSlidingBorder} from '../animations';

const availableSliderControllers = [];

export default class extends Controller {

    static get targets() {
        return ['slider', 'thumbs'];
    }

    connect() {
        availableSliderControllers.push(this);
        const element = this.element;
        let slider = this.targets.find('slider');
        const useThumbs = this.targets.find('thumbs');
        if (!slider) {
            slider = element;
        }

        import('swiper').then(Swiper => {
            import('swiper/modules').then(SwiperModules => {
                const { Navigation, Pagination, Autoplay, Thumbs } = SwiperModules;
                const additionalConfig = slider.hasAttribute('data-swiper') ? JSON.parse(slider.getAttribute('data-swiper')) : {};
                // Config https://swiperjs.com/swiper-api
                const config = {
                    spaceBetween: 0,
                    modules: [Navigation, Pagination, Autoplay, Thumbs],
                    ...additionalConfig,
                };
                let thumbsSwiper;
                if (useThumbs) {
                    const additionalConfig2 = useThumbs.hasAttribute('data-swiper') ? JSON.parse(useThumbs.getAttribute('data-swiper')) : {};
                    const config2 = {
                        spaceBetween: 0,
                        modules: [Navigation, Thumbs],
                        ...additionalConfig2,
                    };
                    thumbsSwiper = new Swiper.default(useThumbs, config2);
                    config['thumbs']['swiper'] = thumbsSwiper;
                }

                if ('customPagination' in config && 'customPaginationItems' in config) {
                    config['pagination']['renderBullet'] = function (index, className) {
                        return `<span class="${className}">${config['customPaginationItems'][index]}</span>`;
                    };
                }

                if ('initBreakpoint' in config) {
                    if (window.innerWidth <= config['initBreakpoint']) {
                        this.swiper = new Swiper.default(slider, config);
                    }
                    window.addEventListener('resize', () => {
                        if (window.innerWidth <= config['initBreakpoint']) {
                            if (!this.swiper) {
                                this.swiper = new Swiper.default(slider, config);
                            }
                        } else if (this.swiper) {
                            const wrapper = this.swiper.wrapperEl;
                            this.swiper.destroy();
                            const parent = wrapper.parentNode;
                            while (wrapper.firstChild) {
                                parent.insertBefore(wrapper.firstChild, wrapper);
                            }
                            parent.removeChild(wrapper);
                            this.swiper = null;
                        }
                    })
                } else {
                    this.swiper = new Swiper.default(slider, config);
                }

                navigationSlidingBorder();
                this.swiper.on('paginationUpdate', (swiper, paginationEl) => {
                    navigationSlidingBorder();

                    if (paginationEl) {
                        const activeItem = paginationEl.querySelector('.swiper-pagination-bullet-active');
                        if (activeItem) {
                            const paginationContainer = paginationEl.parentElement;
                            const containerRect = paginationContainer.getBoundingClientRect();
                            const activeRect = activeItem.getBoundingClientRect();
                            const scrollLeft = paginationContainer.scrollLeft + activeRect.left - containerRect.left - (containerRect.width / 2 - activeRect.width / 2);
                            paginationContainer.scrollTo({
                                left: scrollLeft,
                                behavior: "smooth",
                            });
                        }
                    }
                });

                if ('onClickAlignLeft' in config) {
                    this.swiper.on('click', (swiper, event) => {
                        swiper.slideTo(swiper.clickedIndex);
                    });
                }

                if ('onHoverAlignLeft' in config) {
                    slider.addEventListener('mouseover', (event) => {
                        const slide = event.target.closest('.swiper-slide');
                        if (slide) {
                            const index = Array.from(this.swiper.slides).indexOf(slide);
                            this.swiper.slideTo(index);
                        }
                    });
                }

                if ('customTransition' in config) {
                    const interleaveOffset = 0.5;
                    this.swiper.on('progress', (swiper, progress) => {
                        for (let i = 0; i < swiper.slides.length; i++) {
                            const slideProgress = swiper.slides[i].progress;
                            const innerOffset = swiper.width * interleaveOffset;
                            const innerTranslate = slideProgress * innerOffset;
                            const slide = swiper.slides[i];
                            const elementsToTransition = slide.querySelectorAll('.slide-transition-element');
                            if (elementsToTransition) {
                                for (const element of elementsToTransition) {
                                    element.style.transform = "translateX(" + innerTranslate * 2 + "px)";
                                }
                            }
                            slide.querySelector(".background").style.transform = "translate3d(" + innerTranslate + "px, 0, 0)";
                        }
                    });

                    this.swiper.on('touchStart', (swiper, event) => {
                        for (let i = 0; i < swiper.slides.length; i++) {
                            swiper.slides[i].style.transition = "";
                        }
                    });

                    this.swiper.on('setTransition', (swiper, speed) => {
                        for (let i = 0; i < swiper.slides.length; i++) {
                            const slide = swiper.slides[i];
                            slide.style.transition = speed + 'ms';
                            slide.querySelector('.background').style.transition = speed + 'ms';
                            const elementsToTransition = slide.querySelectorAll('.slide-transition-element');
                            if (elementsToTransition) {
                                for (const element of elementsToTransition) {
                                    element.style.transition = speed + 'ms';
                                }
                            }
                        }
                    });
                }
            });
        });
    }
}
